import { newUuid } from '@krp/client-runtime'

/** UUID намерения человека — генератор client-runtime (с запасным путём вне secure context). */
export { newUuid }

/**
 * Намерение команды: наш UUID операции и ключ идемпотентности. Создаётся ОДИН
 * раз на нажатие человека; повтор того же намерения — тот же ключ, новое
 * нажатие — новый (ADR-11).
 */
export interface CommandIntent {
  operationId: string
  idempotencyKey: string
}

export function newCommandIntent(): CommandIntent {
  return commandIntentOf(newUuid())
}

/**
 * Намерение по уже созданному `operationId`: ключ идемпотентности выводится из него, поэтому в хранилище браузера лежит только id
 * операции, а повтор после F5 уходит с тем же ключом (очередь корзины и повтор оплаты, RP-SALE-FAST).
 */
export function commandIntentOf(operationId: string): CommandIntent {
  return { operationId, idempotencyKey: `aqsi-ui:${operationId}` }
}
